module.exports = __webpack_public_path__ + "static/airbnb.002e2332.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/airbnb.jpg
// module id = 836
// module chunks = 73261030922168